// extracted by mini-css-extract-plugin
export var avatarContainer = "_9f-0";
export var avatarTypingWave = "_9f-i";
export var gray = "_9f-f";
export var green = "_9f-c";
export var icon = "_9f-9";
export var image = "_9f-1";
export var lg = "_9f-6";
export var md = "_9f-5";
export var presenceDot = "_9f-b";
export var red = "_9f-d";
export var sm = "_9f-4";
export var status = "_9f-a";
export var typingDot = "_9f-h";
export var typingPill = "_9f-g";
export var xl = "_9f-7";
export var xs = "_9f-3";
export var xxl = "_9f-8";
export var xxs = "_9f-2";
export var yellow = "_9f-e";